var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.75C22.5359 15.75 22.0908 15.5656 21.7626 15.2374C21.4344 14.9092 21.25 14.4641 21.25 14C21.25 13.5359 21.4344 13.0908 21.7626 12.7626C22.0908 12.4344 22.5359 12.25 23 12.25C23.4641 12.25 23.9092 12.4344 24.2374 12.7626C24.5656 13.0908 24.75 13.5359 24.75 14C24.75 14.4641 24.5656 14.9092 24.2374 15.2374C23.9092 15.5656 23.4641 15.75 23 15.75ZM16 15.75C15.5359 15.75 15.0908 15.5656 14.7626 15.2374C14.4344 14.9092 14.25 14.4641 14.25 14C14.25 13.5359 14.4344 13.0908 14.7626 12.7626C15.0908 12.4344 15.5359 12.25 16 12.25C16.4641 12.25 16.9092 12.4344 17.2374 12.7626C17.5656 13.0908 17.75 13.5359 17.75 14C17.75 14.4641 17.5656 14.9092 17.2374 15.2374C16.9092 15.5656 16.4641 15.75 16 15.75ZM9 15.75C8.53587 15.75 8.09075 15.5656 7.76256 15.2374C7.43437 14.9092 7.25 14.4641 7.25 14C7.25 13.5359 7.43437 13.0908 7.76256 12.7626C8.09075 12.4344 8.53587 12.25 9 12.25C9.46413 12.25 9.90925 12.4344 10.2374 12.7626C10.5656 13.0908 10.75 13.5359 10.75 14C10.75 14.4641 10.5656 14.9092 10.2374 15.2374C9.90925 15.5656 9.46413 15.75 9 15.75ZM4 4V24H10V29L17 24H28V4H4Z",
    fill: "#706E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.bf2f577d8777a56ced0792f8d5a61888.svg";
export { ForwardRef as ReactComponent };